import * as ngRouter from '@angular/router'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as models from '../models'
import type { Feature } from '../feature'

/**
 * Catches navigation requests that did not go through this feature's
 * `navigate` action, such as direct Angular routerLink usage.
 */
export const startOnRouterRequest = store.effects.create(
  (feature: Feature, routerFeature: router.Router) =>
    routerFeature.ngRouter.events.pipe(
      rxjs.filter(
        (event): event is ngRouter.NavigationStart =>
          event instanceof ngRouter.NavigationStart,
      ),
      rxjs.withLatestFrom(feature.selectors.transition.asObservable),
      // This effect covers navigation that bypasses NavigationFeature.navigate
      // entirely. If a transition is already running, let the owner finish it.
      rxjs.filter(
        ([event, transition]) =>
          transition === undefined &&
          models.AppTransition.shouldShow({
            currentUrl: routerFeature.ngRouter.url,
            targetUrl: event.url,
          }),
      ),
      rxjs.map(() =>
        feature.actions.startTransition.from('Router.Requested').create(),
      ),
    ),
)
